export default {
	tab_manager_close_all_tabs_context_menu_label: 'Alle Tabs schließen',
	tab_manager_close_other_tabs_context_menu_label: 'Andere Tabs schließen',
	tab_manager_close_tab_context_menu_label: 'Tab schließen',
	tab_manager_unsaved_changes_dialog_abort_label: 'Abbrechen',
	tab_manager_unsaved_changes_dialog_confirm_cancel_label: 'Verwerfen',
	tab_manager_unsaved_changes_dialog_confirm_message:
		'Sie haben noch ungespeicherte Änderungen. Möchten Sie diese speichern?',
	tab_manager_unsaved_changes_dialog_confirm_ok_label: 'Speichern',
	tab_manager_unsaved_changes_dialog_confirm_title: 'Ungespeicherte Änderungen',
	tab_manager_unsaved_changes_dialog_save_all_label: 'Alle speichern',
	tab_manager_unsaved_changes_dialog_send_label: 'Senden',
	tab_manager_unsaved_changes_dialog_unsent_title: 'Ungesendete Nachricht',
};
